// Einstellungen → Kalender: iCal-Abo-Link (nur lesen) aus Flow für Apple-/Google-Kalender am Handy.
import { useEffect, useState } from 'react';
import { api } from '../lib/api.ts';
import { toast } from './Toast.tsx';

export function KalenderSettings() {
  const [ical, setIcal] = useState<{ url: string | null; error?: string } | null>(null);
  useEffect(() => {
    void api.flowIcal().then(setIcal);
  }, []);
  const copy = async () => {
    if (!ical?.url) return;
    try {
      await navigator.clipboard.writeText(ical.url);
      toast('Link kopiert');
    } catch {
      toast('Kopieren nicht möglich – Link markieren und kopieren.');
    }
  };
  return (
    <div className="s-snip">
      <div>
        Quellen im Reiter „Flow“: Flow-Termine (Till, Lars, Maren) und Flow-Aufgaben.
        Minimusikertage und Aufnahmen aus dem CRM folgen.
      </div>
      <div style={{ marginTop: 8 }}>
        <b>iCal-Abo</b> (nur lesen, für Apple- oder Google-Kalender):
      </div>
      {!ical && <div className="muted">wird geladen …</div>}
      {ical && !ical.url && (
        <div className="muted" style={{ fontSize: 12 }}>
          Noch nicht verfügbar{ical.error ? ` (${ical.error})` : ' – Flow ist nicht angebunden.'}
        </div>
      )}
      {ical?.url && (
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 4 }}>
          <input
            readOnly
            value={ical.url}
            onFocus={(e) => e.currentTarget.select()}
            style={{
              flex: 1,
              font: 'inherit',
              fontSize: 12,
              padding: '4px 8px',
              borderRadius: 8,
              border: '1px solid var(--line)',
              background: 'var(--bg)',
              color: 'var(--fg)',
            }}
          />
          <button className="btn sm" onClick={() => void copy()}>
            Kopieren
          </button>
        </div>
      )}
      <div className="muted" style={{ fontSize: 12, marginTop: 4 }}>
        Am iPhone: Einstellungen → Kalender → Accounts → Account hinzufügen → Andere → Kalenderabo.
        Der Link ist persönlich – nicht weitergeben.
      </div>
    </div>
  );
}
